export function useUserCheck(): void {
    document.addEventListener("visibilitychange", () => {
        if (!document.hidden) {
            console.log('App: Tab visibile - checking session')
            const token = document.cookie.includes('token=')
            if (!token) {
                console.log('App: No session')
                window.location.assign('/')
            }    
        }
    })
    console.log('App: Tab visibility change event bound')
}